<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// 入口组件
export default {
  name: 'App',
  created () {
    let currentVersion = require('../package.json').version
    let localVersion = localStorage.getItem('oohforce-website')
    if (localVersion) { // 判断是否和当前版本一致
      if (localVersion !== currentVersion) {
        localStorage.setItem('oohforce-website', currentVersion)
        window.location.reload() // 强制刷新页面
      }
    } else {
      localStorage.setItem('oohforce-website', currentVersion)
      window.location.reload() // 强制刷新页面
    }

    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('store'))
        )
      )
    }

    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    // beforeunload事件在页面刷新时先触发
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$store.state.user.companySetting) {
        document.getElementById('app').className = this.$store.state.user.companySetting.cssname || 'default'
      } else {
        document.getElementById('app').className = 'default'
      }
    })
  }
}
</script>
